import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Example from "../components/SalePanel";
import MobileHomePage from "../pages/MobileHomePage";
import MobileTestPage from "../pages/MobileTestPage";
import MobileMarketplace from "../pages/MobileMarketplace";
import ErrorBoundary from "../components/ErrorBoundary";
import Login from "../pages/Login";
import MobileMyList from "../pages/MobileMyList";
import EthicsPage from "../pages/EthicsPage";
import TermsPage from "../pages/TermsPage";
import PressPage from "../pages/PressPage";
import PrivacyPage from "../pages/PrivacyPage";
import { Wallet } from "../pages/wallets";
import { getCategories, getProductNames } from "../Redux/options/slice";
import { getProductsList } from "../Redux/products/slice";
import { ProtectedRoute } from "./ProtectedRoute";
import MobileTransactionExplorer from "../components/MobileTransactionExplorer";
import MyGPT from "../pages/VertoGPT";
import CertificatePage from "../components/CertificatePage";
import CookiesPolicy from "../pages/CookiesPolicy";
import ProfilePresentation from "../components/ProfilePresentation";
import EudrReportsPage from "../pages/EudrReportsPage";
import SignUpFormPage from "../pages/SignUpFormPage";

const MainContent = () => {
  return (
    <div className="d-flex flex-column sticky-footer" style={{ overflow: "hidden" }}>
      <Routes>
        <Route
          index
          element={
            <ErrorBoundary>
              <MobileHomePage />
            </ErrorBoundary>
          }
        />
        <Route path="/test" element={<MobileTestPage />} />
        <Route path="/home" element={
          <ErrorBoundary>
            <MobileHomePage />
          </ErrorBoundary>
        } />
        <Route path="/login" element={<Login />} />
        <Route
          // path="/home/:level"
          path="/marketplace"
          element={
            // <ProtectedRoute>
            <MobileMarketplace />
            // </ProtectedRoute>
          }
        />
        <Route
          path="/my-list"
          element={
            <ProtectedRoute>
              <MobileMyList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/wallet/:userId/:walletId"
          element={
            <ProtectedRoute>
              <Wallet />
            </ProtectedRoute>
          }
        />
        <Route
          path="/wallet"
          element={
            <ProtectedRoute>
              <Wallet />
            </ProtectedRoute>
          }
        />
        <Route path="/transaction-explorer" element={<MobileTransactionExplorer />} />
        <Route
          // path="/home/:level"
          path="/gpt"
          element={<MyGPT />}
        />
        <Route path="/signup-form" element={<SignUpFormPage />} />
        <Route path="/signup" element={<Navigate to="/signup-form" replace />} />
        <Route
          path="/eudr-reports"
          element={
            <ProtectedRoute>
              <EudrReportsPage />
            </ProtectedRoute>
          }
        />
        <Route path="/ethics" element={<EthicsPage />} />
        <Route path="/cookies-policy" element={<CookiesPolicy />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/press" element={<PressPage />} />
        <Route path="/certificate/:id" element={<CertificatePage />} />
        <Route path="/productcertificate/:id" element={<CertificatePage />} />
        <Route path="/profile/:accountId" element={<ProfilePresentation />} />
      </Routes>
    </div>
  );
};

const MobileWebRouter = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    try {
      dispatch(getCategories());
      dispatch(getProductsList());
      // dispatch(getProductNames())
    } catch (error) {
      console.error('Error initializing mobile router:', error);
    }
  }, []);

  return (
    <BrowserRouter>
      <MainContent />
    </BrowserRouter>
  );
};

export default MobileWebRouter;
